// Floor perspective shader (original behavior)
export const perspective = `#version 300 es
precision mediump float;

in vec2 v_uv;
uniform sampler2D u_graphic2;
uniform float u_time;
uniform vec2 u_size;

uniform float u_perspective_strength;
uniform float u_horizon_y;
uniform float u_tilt_angle;
uniform float u_depth_scale;
uniform float u_invert; // 0.0 = floor, 1.0 = ceiling

out vec4 fragColor;

vec2 applyPerspective(vec2 uv, float strength, float horizon, float invert) {
    vec2 centered = uv - 0.5;
    
    // Flip Y coordinate for ceiling mode
    if (invert > 0.5) {
        centered.y = -centered.y;
    }
    
    // Apply perspective: distort X based on Y
    float perspectiveFactor = 1.0 + (centered.y - horizon) * strength;
    centered.x /= perspectiveFactor;
    
    float depthFactor = 1.0 + (centered.y - horizon) * u_depth_scale;
    centered.y /= depthFactor;
    
    // Flip Y back for ceiling mode
    if (invert > 0.5) {
        centered.y = -centered.y;
    }
    
    return centered + 0.5;
}

vec2 applyTilt(vec2 uv, float angle) {
    vec2 centered = uv - 0.5;
    float cosAngle = cos(angle);
    float sinAngle = sin(angle);
    
    vec2 rotated = vec2(
        centered.x * cosAngle - centered.y * sinAngle,
        centered.x * sinAngle + centered.y * cosAngle
    );
    
    return rotated + 0.5;
}

void main() {
    vec2 uv = v_uv;
    
    uv = applyTilt(uv, u_tilt_angle);
    uv = applyPerspective(uv, u_perspective_strength, u_horizon_y, u_invert);
    
    if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) {
        fragColor = vec4(0.0, 0.0, 0.0, 0.0);
        return;
    }
    
    fragColor = texture(u_graphic2, uv);
}`;
